// extracted by mini-css-extract-plugin
export default {"copyrightsCont":"style_copyrightsCont__TWFSc"};